const SEGMENTED_TABS_CLASS_NAME = 'segmented-tabs';

export default SEGMENTED_TABS_CLASS_NAME;
